import React from 'react';

export { getConditionOptions } from './helpers/ConditionalOptions';
export { getExpiryOptions } from './helpers/ExpiryOptions';
export { getPermissionOptions } from './helpers/PermissionsOptions';
export * from './ResourceContext';
export * from './constants';

export const LazyGrantPage = React.lazy(() => import('../Links/GrantFlow/GrantPage'));
export const LazyLinksPage = React.lazy(() => import('./LinksPage'));
export const LazyLinkErrorPage = React.lazy(() => import('./ErrorPages/LinkErrorPage'));
